<template>
  <section class="article_header">
    <div class="wrap">
      <div class="left">
        <router-link to="/">
          <img class="logo" src="/static/v2/header/MANA_head_logo.png" />
        </router-link>
        <h4 v-if="type===1">{{$t('global.文章预览')}}</h4>
        <h4 v-if="type===2">
          {{$t('global.写文章')}}
          <small
            v-if="status!==0"
          >{{status === 1? $t('global.草稿保存中…'):status===2?$t('global.草稿已保存'):''}}</small>
        </h4>
      </div>
      <div class="right">
        <el-button v-if="type===2" @click="preViewArticle">{{$t('global.预览')}}</el-button>
        <el-button v-if="type===1" @click="goBackEdit">{{$t('global.返回编辑')}}</el-button>
        <el-button class="submit" @click="save">{{$t('global.发布')}}</el-button>
        <el-menu mode="horizontal" class="article-link">
          <el-submenu index="/manageCenter">
            <template slot="title">
              <img src="/static/v2/article/article_top_menu_more.png" alt />
            </template>
            <el-menu-item index="/manageCenter" class="header-el-meun user">
              <router-link class="paddingLeft30" to="/my/article?status=-1">{{$t('global.草稿')}}</router-link>
            </el-menu-item>
            <el-menu-item index="/manageCenter" class="header-el-meun user">
              <router-link class="paddingLeft30" to="/my/article">{{$t('global.我的文章')}}</router-link>
            </el-menu-item>
          </el-submenu>
        </el-menu>
        <span class="link-msg" @click="gotoMess('/MessageCenter')">
          <img src="/static/v2/header/notification_icon.png" alt />
        </span>
        <span class="icon-new" :class="{messagenone: messageCount == 0}"></span>
        <el-menu mode="horizontal" class="link-user">
          <el-submenu index="/manageCenter">
            <template slot="title">
              <img
                class="avatar"
                :src="peopleMessage&&peopleMessage.avatar | imageUrl('/static/profile_img_default.png',180,180)"
                @click="goto('/manageCenter')"
              />
            </template>
            <el-menu-item index="/manageCenter" class="header-el-meun user">
              <router-link
                :to="`/peopleCenter/${peopleMessage.userId}`"
                class="paddingLeft30"
              >{{$t('global.我的主页')}}</router-link>
            </el-menu-item>
            <el-menu-item index="/manageVideo" class="header-el-meun user">
              <router-link class="paddingLeft30" to="/manageVideo">{{$t('global.视频管理')}}</router-link>
            </el-menu-item>
            <el-menu-item index="/MyCollect" class="header-el-meun user">
              <router-link class="paddingLeft30" to="/MyCollect">{{$t('global.我的收藏')}}</router-link>
            </el-menu-item>
            <el-menu-item index="/manageCenter" class="header-el-meun user">
              <router-link class="paddingLeft30" to="/manageCenter">{{$t('global.账户设置')}}</router-link>
            </el-menu-item>
            <el-menu-item index="/loginout" class="header-el-meun user">
              <span class="paddingLeft30" @click="loginout">{{$t('global.退出登录')}}</span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
        <el-menu mode="horizontal" class="language">
          <el-submenu index="/language">
            <template slot="title">
              <span class="lang">{{showLanguage}}</span>
            </template>
            <el-menu-item index="/explorevideo">
              <span class="paddingLeft30" @click="changeLanguage('中文')">中文</span>
            </el-menu-item>
            <el-menu-item index="/exploreauth">
              <span class="paddingLeft30" @click="changeLanguage('English')">English</span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["type", "status", "disabled", "preView", "id", "edit", "submit"],
  data() {
    return {
      messageCount: 0
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getMessage();
    },
    gotoMess(path) {
      this.messageCount = 0;
      this.$router.push(path);
    },
    getMessage() {
      let auth_token = localStorage.getItem("auth_token");
      if (auth_token) {
        this.$http.get("/api/customer/count/unread").then(response => {
          if (response.code == "Unauthorized") {
            this.login = false;
            return;
          }
          let data = response.data;
          this.messageCount = data;
        });
        if (auth_token) {
          this.login = true;
        }
      }
    },
    loginout() {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("isLogin");
      localStorage.removeItem("userId");
      this.$store.dispatch("restUser");
      localStorage.setItem("isLogin", "false");
      this.login = false;
    },
    changeLanguage(language) {
      switch (language) {
        case "中文":
          location.hash = "#!zh";
          break;
        case "English":
          location.hash = "#!en";
          break;
      }
      location.reload();
    },
    preViewArticle() {
      this.$emit("preView");
    },
    goBackEdit() {
      this.$emit("edit");
    },
    save() {
      this.$emit("submit");
    }
  },
  computed: {
    peopleMessage() {
      return this.$store.state.peopleMessage;
    },
    showLanguage() {
      if (location.hash) {
        return location.hash === "#!en" ? "EN" : "CN";
      } else if (localStorage.getItem("language")) {
        return localStorage.getItem("language") === "#!en" ? "EN" : "CN";
      } else {
        return "CN";
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.article_header {
  position: fixed;
  z-index: 10;
  top: 0;
  width: 100%;
  padding: 0;
  background: #fff;
  box-shadow: 0px 1px 5px 0px #e0e0e0;
  margin-bottom: 2px;
  height: 66px;
  line-height: 66px;

  .wrap {
    display: flex;
    min-width: 1280px;
    padding: 0 50px;
    flex-direction: row;
    margin: 0 auto;
    align-items: center;
    box-sizing: border-box;
    background: #fff;

    .left {
      display: flex;
      flex-direction: row;
      align-items: center;

      img {
        width: 120px;
        height: 50px;
      }

      h4 {
        font-size: 20px;
        font-weight: 600;
        color: #000;
        padding-left: 95px;

        small {
          font-size: 16px;
          color: #999;
          padding-left: 20px;
        }
      }
    }

    .right {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex: 1;
      justify-content: flex-end;
      height: 66px;

      .article-link {
        .el-submenu {
          padding-left: 20px;
        }

        img {
          width: 26px;
          height: 26px;
          padding: 20px 0;
        }
      }

      .link-msg {
        margin-left: 30px;
        cursor: pointer;
        img {
          width: 20px;
          height: 20px;
        }
      }

      .icon-new {
        height: 9px;
        width: 9px;
        border-radius: 5px;
        background: #FE5630;
        margin-top: -26px;

        &.messagenone {
          display: none;
        }
      }

      .el-button {
        color: #2026CC;
        border-color: #2026CC;
        height: 30px;
        width: 78px;
        padding: 5px 10px;
        border-radius: 0;
        font-weight: bold;
        &:hover {
          border-color: #2026CC;
          background-color: #fff;
        }
        &:disabled {
          border-color: #B8B8B8;
          color: #B8B8B8;

          span {
            color: #B8B8B8;
          }
        }

        span {
          font-size: 14px;
          font-weight: 600;
        }

        &.submit {
          margin-left: 20px;
          color: #fff;
          background: #2026CC;
          border: none;

          &:disabled {
            background: rgba(32, 38, 204, 0.5);
          }
        }
      }

      .link-user {
        margin: 0 10px;
        border-bottom: none;

        img {
          width: 36px;
          height: 36px;
          border-radius: 18px;
          border: 1px solid #f5f5f5;
          margin: 14px 0;
        }
      }
    }
  }
}
</style>

<style lang="stylus">
.el-menu--popup {
  min-width: 125px;
  border-radius: 0;
  margin-top: 0;
  border: 1px solid #EBEBEB;
}

.paddingLeft30 {
  padding-left: 30px;
}

.article_header .link-user.el-menu--horizontal>.el-submenu, .article-link.el-menu.el-menu--horizontal, .language.el-menu.el-menu--horizontal {
  border-bottom: none;

  .el-submenu__title {
    height: 66px;
    line-height: 66px;
    color: #333;

    .el-submenu__icon-arrow {
      &::before {
        content: '';
      }
    }
  }
}

.el-menu--horizontal .el-menu--popup {
  // text-align: center;
}

.link-user, .article-link {
  .el-submenu__title {
    overflow: hidden;

    .el-submenu__icon-arrow {
      display: none;
    }
  }
}

.el-menu--horizontal .el-menu .el-menu-item.header-el-meun {
  // width: 125px;
  padding: 0;

  &.user {
    // width: 100px;
  }

  a, span {
    display: block;
    padding-left: 30px;
    color: #333;
    &:hover {
      background: rgba(245, 245, 245, 1);
    }
  }
}

.language {
  .el-submenu__title {
    padding: 0;
  }

  .lang {
    &::before {
      content: '';
      display: inline-block;
      height: 18px;
      width: 18px;
      background: url('/static/v2/header/lang_icon.png') no-repeat;
      background-size: 18px;
      vertical-align: -4px;
      margin-right: 3px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/v2/article/articleHeader.vue